export const LANG = {
    appointmentBased: 'Appointment based',
    at: 'at',
    apply: 'Apply',
    backToResults: 'Back to Results',
    backToFitterDetails: 'Back to Fitter Details',
    bookAFitting: 'Book a Fitting',
    certifiedFitter: 'PING Certified Fitter',
    clear: 'Clear',
    clearAll: 'Clear All',
    clearFilters: 'Clear Filters',
    closeEventsList: 'Close events list',
    closed: 'Closed',
    closesAt: 'Closes at',
    daysOfTheWeek: {
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat',
        sun: 'Sun',
        Monday: 'Monday',
        Tuesday: 'Tuesday',
        Wednesday: 'Wednesday',
        Thursday: 'Thursday',
        Friday: 'Friday',
        Saturday: 'Saturday',
        Sunday: 'Sunday',
    },
    demoDayDetails: 'Demo Day Details',
    drivingDirections: 'Driving Directions',
    errors: {
        locationDetailsCanNotBeDislayed: 'An error has occurred. Location details can not be displayed at this time.',
        filterLocationsCanNotBeDislayed: 'An error has occurred. Fitter locations can not be displayed at this time.',
    },
    eventType: 'Event Type',
    events: 'Events',
    featuresAndAmenities: 'Features & Amenities',
    findAFitter: 'Find a Fitter',
    findAPingFitter: 'FIND A PING FITTER',
    findAPingFitterNearYou: 'Find a PING Fitter Near You',
    findingFitters: 'Finding fitters',
    fittingLocationFound: 'Fitting Location Found',
    fittingLocationsFound: 'Fitting Locations Found',
    fittersFound: 'Fitters Found',
    noFittingLocationsFoundTitle: 'No fitting locations found.',
    noFittingLocationsFoundDescription: 'Try zooming out or adjusting your search criteria.',
    filters: 'Filters',
    filter: 'Filter',
    filterBy: 'Filter By',
    hours: 'Hours',
    kilometers: 'Kilometers',
    loadingDetails: 'Loading Details',
    mapSearchBox: {
        ariaLabel: 'Find a PING Fitter Near You using the Address, State or Zip Code',
        placeholder: 'Search Address, State or Zip Code...',
    },
    messages: {
        externalLink:
            'By clicking OK, you are leaving ping.com and will be redirected to a third-party website. PING is not responsible for the content, privacy policies, or practices of any third-party sites. We encourage you to review the privacy and security policies of the website you are visiting.',
    },
    miles: 'Miles',
    mobileFitting: 'Mobile Fitting',
    moreDetails: 'More Details',
    noLocationsFound: 'No locations found.',
    open: 'Open',
    opens: 'Opens',
    opensAt: 'Opens at',
    pingFittingExperience: 'PING Fitting Experience',
    pingMobileFittingExperience: 'PING Mobile Fitting Experience',
    pldMilled: 'PLD Milled',
    powerFitterOfTheYear: 'PING Power Fitter',
    radius: 'Radius',
    showResults: 'Show Results',
    default: 'Default',
    selectAnEvent: 'Select an Event',
    distance: 'Distance',
    sort: 'Sort',
    sortBy: 'Sort By',
    sortByDefault: 'SORT BY: Default',
    sortByDistance: 'SORT BY: Distance',
    distanceIn: 'DISTANCE IN: ',
    viewAllEvents: 'View All Events',
    viewDetails: 'View Details',
    walkUpAppointments: 'Walk-up appointments',
    weeklyAvailability: 'Weekly Availability',
    footer: {
        left: [
            {
                type: 'text',
                title: 'A Custom Fitting Experience Like No Other',
            },
            {
                type: 'text',
                description:
                    'Whether your fitting takes place inside a golf-shop hitting bay, on a driving range, at The PING Proving Grounds or at one of the many PING Fitting Days held every season, you will enjoy the custom-fitting expertise and personalized service that distinguish a PING fitting experience.',
            },
            {
                type: 'link',
                key: 'fittingProcessUrl',
                href: 'https://next.ping.com/en-us',
                text: 'Our Fitting Process',
                target: '_self',
            },
        ],
        fittingExperience: {
            legends: [
                {
                    badgeText: 'PING FITTING EXPERIENCE',
                    badgeIcon: 'logo',
                    badgeColor: 'purple',
                    title: 'PING Fitting Experience',
                    links: [
                        {
                            key: 'scheduleFittingUrl',
                            href: 'https://calendly.com/pingfittingexperience',
                            text: 'Learn More',
                            target: '_self',
                        },
                    ],
                    paragraphs: [
                        'PING-employed fitters conduct full bag and individual club fittings at multiple locations throughout Phoenix to deliver personalized recommendations.',
                    ],
                },
                {
                    badgeText: 'PING Power Fitter',
                    badgeIcon: 'power',
                    badgeColor: 'green',
                    title: 'PING Power Fitter',
                    paragraphs: [
                        'An exclusive honor reserved for top PING fitters who demonstrate expertise in custom fitting every club in the bag with the highest level of personalized service.',
                    ],
                },
                {
                    badgeText: 'PING CERTIFIED FITTER',
                    badgeIcon: 'ribbon',
                    badgeColor: 'blue',
                    title: 'PING Certified Fitter',
                    paragraphs: [
                        'Experts certified in the entire PING fitting process (metal woods, irons, wedges and putters) who’ve completed multiple PING fitting and golf science training courses.',
                    ],
                },
            ],
        },
    },
}
